import React from 'react';
import { IconUtils, type IconType } from '@/utils';

export type ToastType = IconType;

export interface AppToastContentProps {
  type: ToastType;
  message: string;
  /** When false, no icon (e.g. if notification provides its own) */
  showIcon?: boolean;
}

const AppToastContent: React.FC<AppToastContentProps> = ({ type, message, showIcon = true }) => {
  const config = IconUtils.getToastConfig(type);
  return (
    <div className={`min-w-[280px] max-w-[420px] rounded-md px-4 py-3 ${config.containerClass}`}>
      <div className="flex items-center">
        {showIcon && IconUtils.getIcon(type, true)}
        <p className={`mb-0 ${config.textClass}`}>{message}</p>
      </div>
    </div>
  );
};

export default AppToastContent;
